import { ViewInstallationQuotationModal } from "@/features/orders/installationQuotation/ViewInstallationQuotationModal";
import {
  type InstallationQuotationStatus,
  type InstallationQuotationWidgetList,
} from "@repo/api";
import { LightMode, ListView, ListViewItem } from "@repo/skapa";
import { t, useTranslation } from "@repo/translation";
import {
  SimpleLabelField,
  localizeDate,
  translateInstallationQuotationStatus,
} from "@repo/ui";
import { useState } from "react";

interface InstallationQuotationsListProps {
  installationQuotations: InstallationQuotationWidgetList[];
}

export const InstallationQuotationList = ({
  installationQuotations,
}: InstallationQuotationsListProps) => {
  const { dateFnsLocale } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedQuotation, setSelectedQuotation] = useState<
    InstallationQuotationWidgetList | undefined
  >(undefined);

  return (
    <>
      <ListView id="workspace-installation-quotation-list">
        {installationQuotations.map((installationQuotation) => (
          <ListViewItem
            key={installationQuotation.installationQuotationId}
            title={installationQuotation.projectName ?? ""}
            control="navigational"
            description={
              <SimpleLabelField
                label={t("label.status")}
                value={translateInstallationQuotationStatus(
                  installationQuotation.status as InstallationQuotationStatus
                )}
                color={LightMode.colourTextAndIcon2}
                small
              />
            }
            addOn={
              <SimpleLabelField
                label={t("label.installation_start_date")}
                value={
                  installationQuotation.installationStartDate
                    ? localizeDate(
                        installationQuotation.installationStartDate,
                        dateFnsLocale
                      )
                    : "-"
                }
                color={LightMode.colourTextAndIcon3}
                small
              />
            }
            onClick={() => {
              setSelectedQuotation(installationQuotation);
              setIsModalOpen(true);
            }}
          />
        ))}
      </ListView>

      <ViewInstallationQuotationModal
        isOpen={isModalOpen && Boolean(selectedQuotation)}
        closeModal={() => setIsModalOpen(false)}
        installationQuotation={selectedQuotation}
      />
    </>
  );
};
